import { render } from "./OutlineUnreadAnnouncement.vue?vue&type=template&id=da91d426"
import script from "./OutlineUnreadAnnouncement.vue?vue&type=script&lang=js"
export * from "./OutlineUnreadAnnouncement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__